import React from "react";

const QualificatinData = ({ title, location, time }) => {
  return (
    <div className="qualification__data">
      <div>
        <h3 className="qualification__title"> {title} </h3>
        <span className="qualification__subtitle">{location}</span>
        <div className="qualification__calender">
          <i className="uil uil-calendar-alt"></i>
          {time}
        </div>
      </div>

      <div>
        <span className="qualification__rounder"></span>
        <span className="qualification__line"></span>
      </div>
    </div>
  );
};

export default QualificatinData;
